import { Group, Input, SegmentedControl, SegmentedControlItem, Text } from '@byecode/ui'
import { AnchorBehaviorEnum } from '@lighthouse/core'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { OffsetInput } from './OffsetInput'

interface AnchorSettingProps {
    title?: string
}

const ANCHOR_BEHAVIOR_OPTIONS: SegmentedControlItem[] = [
    {
        label: '默认',
        value: AnchorBehaviorEnum.INSTANT
    },
    {
        label: '平滑',
        value: AnchorBehaviorEnum.SMOOTH
    }
]

export const AnchorSetting: React.FC<AnchorSettingProps> = ({ title = '锚点' }) => {
    const { control } = useFormContext()
    return (
        <Group label={title}>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <Text>组件标识</Text>
                <Controller
                    name="anchor.anchorId"
                    control={control}
                    render={({ field }) => <Input value={field.value} style={{ width: 180 }} onBlur={field.onChange} />}
                />
            </ListItem4ByecodeUi>

            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <Text>偏移量</Text>
                <Controller
                    name="anchor.offset"
                    control={control}
                    render={({ field }) => <OffsetInput value={field.value} onChange={field.onChange} />}
                />
            </ListItem4ByecodeUi>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <Text>滚动过渡</Text>
                <Controller
                    name="anchor.behavior"
                    control={control}
                    render={({ field }) => (
                        <SegmentedControl
                            style={{ width: 180 }}
                            fullWidth
                            value={field.value ?? AnchorBehaviorEnum.INSTANT}
                            onChange={field.onChange}
                            data={ANCHOR_BEHAVIOR_OPTIONS}
                        />
                    )}
                />
            </ListItem4ByecodeUi>
        </Group>
    )
}
